import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Blogomat360 from './pages/Blogomat360';
import Chatbot360 from './pages/Chatbot360';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import FooterMain from './components/FooterMain';
import FooterBottomBar from './components/FooterBottomBar';
import CookieSettings from './components/CookieSettings';
import ContactFormTwo from './components/ContactFormTwo';



function App() {


  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <header className="App-header">
          <Header />
        </header>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blogomat360" element={<Blogomat360 />} />
          <Route path="/chatbot360" element={<Chatbot360 />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

        <div className='contact-popup'>
          <ContactFormTwo />
        </div>
        <footer className="App-footer">
          <FooterMain />
          <FooterBottomBar />
          <CookieSettings />

        </footer>
      </div>
    </Router>
  );
}

export default App;
